import type { ClassNameValue } from 'tailwind-merge'
import { extendTailwindMerge } from 'tailwind-merge'

import semanticColors from '../../tokens/semanticColors.json'
import semanticTypography from '../../tokens/semanticTypography.json'

// During the token migration both legacy and new class names are emitted by the
// tailwind config, so tailwind-merge must know both to dedupe them correctly.
// The legacy spread can be dropped once all call sites use the new names.
const semanticColorKeys = { ...semanticColors['mode-1'] }

const getFontSizeCustomClassNames = (fontSizes: Record<string, string>) => Object.keys(fontSizes).map(key => 'text-' + key)

const getTextColorCustomClassNames = (textColors: Record<string, string>) => Object.keys(textColors).filter(key => key.startsWith('text-'))
const getBgColorCustomClassNames = (bgColors: Record<string, string>) => Object.keys(bgColors).filter(key => key.startsWith('bg-'))

const extendedTwMerge = extendTailwindMerge({
    extend: {
        classGroups: {
            'font-size': [
                // Custom font sizes
                ...getFontSizeCustomClassNames(semanticTypography.fontSize),
            ],
            'text-color': [
                // Custom font colors
                ...getTextColorCustomClassNames(semanticColorKeys),
            ],
            'bg-color': [
                // Custom background colors
                ...getBgColorCustomClassNames(semanticColorKeys),
            ],
            'bg-image': [
                // Custom gradient color utilities
                'bg-gradient-brand-to-magic',
                'bg-dashed-surface-strong',
            ],
            shadow: [
                // Custom shadow classes
                'shadow-diCard',
                'shadow-button-active',
                'shadow-glass',
                'shadow-borders',
                'shadow-secondary-button',
                'shadow-card',
                'shadow-hovercard',
                'shadow-data-card',
                'shadow-tooltip',
                'shadow-dropdown',
                'shadow-popover',
                'shadow-dialog',
            ],
        },
    },
    override: {
        classGroups: {
            // These classes set CSS custom properties and must NOT conflict with each other
            // Each direction gets its own group so they can be combined
            // @ts-expect-error - Creating custom class groups for non-conflicting border utilities
            'shadow-border-t': ['shadow-border-t'],
            'shadow-border-r': ['shadow-border-r'],
            'shadow-border-b': ['shadow-border-b'],
            'shadow-border-l': ['shadow-border-l'],
        },
    },
})

export const astraTwMerge = (...classes: ClassNameValue[]) => extendedTwMerge(...classes)
